
export const setVolumeRecebidos = (receivedVolumes) => {
    return {
        type: 'SET_PHISICAL_CONFIRMATION_MONITOR',
        receivedVolumes,
    };
};

export const setPedidosAtendidos = (quantitys) => {
    return {
        type: 'SET_ORDERS_ATTENDED_MONITOR',
        quantitys,
    };
};

export const setTrocasLocacaoFeitas = (quantitys) => {
    return {
        type: 'SET_CHANGE_LOCATION_MONITOR',
        quantitys,
    };
};

export const setMvmCarregados = (mvmCarregados) => {
    return {
        type: 'SET_MVM_LOAD_UNLOAD_MONITOR',
        mvmCarregados,
    };
};

export const resetMonitor = () => {
    return {
        type: 'RESET_MONITOR'
    };
};